export default __webpack_public_path__ + "static/media/key.0cfa4d52.svg";